import styled from 'styled-components';

export const Container = styled.div`
  padding: 16px 44px;
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const CardsContainer = styled.div`
  display: flex;
  gap: 16px;
  flex-flow: wrap;
  justify-content: stretch;
`;
